// extracted by mini-css-extract-plugin
export default {"main":"EnhancementPage_main__8LQiy","mainWithGradient":"EnhancementPage_mainWithGradient__w3vgT","container":"EnhancementPage_container__6iPlQ"};